import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    error: false,
    subdomain: '',
    tempSubdomain: '',
    hasSubdomain: false,
    subdomainAppId: '',
    available: false,
    webPublication_loading: false,
    webPublication_error: false,
    webMeta: {
        name: null,
        icon: null,
        textColor: '#828282',
        bgColor: '#ffffff',
    },
    firebaseSecret_loading: false,
    firebaseSecret_error: false,
    hasFirebaseSecret: false,
    firebaseProjectId: '',
    firebaseSecretSave_loading: false,
    firebaseSecretSave_error: false,
    certificateDetails_loading: false,
    certificateDetails: [],
    certificateDetails_error: false,
    check_loading: false,
    check_error: false,
    androidBundleId: '',
    androidBundleCheckAppId: '',
    appStoreSecret_loading: false,
    appStoreSecret_error: false,
    hasAppStoreSecret: false,
    appStoreSecretSave_loading: false,
    appStoreSecretSave_error: false,
    iosBundle_loading: false,
    iosBundle_error: false,
    revoke_loading: false,
    revoke_error: false,
    createLicense_loading: false,
    createLicense_error: false,
    iosBundleId: '',
    iosBundleCheckAppId: '',
    iosTeamId: '',
    projectID: '',
    cert_loading: false,
    cert_error: false,
    down_error: false,
    cert: false,
    ios_license: null,
    pwa_license: null,
    android_license: null,
    has_license_loading: false,
}); };
function platformReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'ACCOUNTS_ANDROID_PUB_CERT_REQUEST':
                state.cert_loading = true;
                state.cert_error = false;
                break;
            case 'ACCOUNTS_ANDROID_PUB_CERT_SUCCESS':
                state.cert_loading = false;
                state.cert_error = false;
                state.cert = true;
                break;
            case 'ACCOUNTS_ANDROID_PUB_CERT_CHECK_FAILURE':
                state.cert_loading = false;
                state.cert_error = false;
                state.cert = false;
                break;
            case 'ACCOUNTS_ANDROID_PUB_CERT_FAILURE':
                state.cert_loading = false;
                state.cert_error = true;
                state.cert = false;
                break;
            case 'ACCOUNTS_ANDROID_PUB_CERT_DOWNLOAD_REQUEST':
                state.down_error = false;
                break;
            case 'ACCOUNTS_ANDROID_PUB_CERT_DOWNLOAD_FAILURE':
                state.down_error = true;
                break;
            case 'ACCOUNTS_FIREBASE_IOS_APP_SETUP_REQUEST':
                state.iosBundle_loading = true;
                state.iosBundle_error = false;
                break;
            case 'ACCOUNTS_FIREBASE_IOS_APP_SETUP_SUCCESS':
                state.iosBundle_loading = false;
                state.iosBundle_error = false;
                state.iosBundleId = action.iosBundleId || '';
                break;
            case 'ACCOUNTS_FIREBASE_IOS_APP_SETUP_FAILURE':
                state.iosBundle_loading = false;
                state.iosBundle_error = true;
                break;
            case 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_REQUEST':
                state.iosBundle_loading = true;
                state.iosBundle_error = false;
                break;
            case 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_SUCCESS':
                state.iosBundle_loading = false;
                state.iosBundle_error = false;
                state.iosBundleId = action.iosBundleId || '';
                state.projectID = action.projectID || '';
                state.iosTeamId = action.teamId || '';
                state.iosBundleCheckAppId = action.iosBundleCheckAppId || '';
                break;
            case 'ACCOUNTS_FIREBASE_IOS_APP_CHECK_FAILURE':
                state.iosBundle_loading = false;
                state.iosBundle_error = true;
                state.iosBundleId = '';
                state.projectID = '';
                state.iosTeamId = '';
                break;
            case 'ACCOUNTS_APP_STORE_CONNECT_SAVE_SECRET_REQUEST':
                state.appStoreSecretSave_loading = true;
                state.appStoreSecretSave_error = false;
                break;
            case 'ACCOUNTS_APP_STORE_CONNECT_SAVE_SECRET_SUCCESS':
                state.appStoreSecretSave_loading = false;
                state.appStoreSecretSave_error = false;
                state.hasAppStoreSecret = true;
                break;
            case 'ACCOUNTS_APP_STORE_CONNECT_SAVE_SECRET_FAILURE':
                state.appStoreSecretSave_loading = false;
                state.appStoreSecretSave_error = true;
                break;
            case 'ACCOUNTS_APP_STORE_CONNECT_HAS_SECRET_REQUEST':
                state.appStoreSecret_loading = true;
                state.appStoreSecret_error = false;
                break;
            case 'ACCOUNTS_APP_STORE_CONNECT_HAS_SECRET_SUCCESS':
                state.appStoreSecret_loading = false;
                state.appStoreSecret_error = false;
                state.hasAppStoreSecret = true;
                break;
            case 'ACCOUNTS_APP_STORE_CONNECT_HAS_SECRET_FAILURE':
                state.appStoreSecret_loading = false;
                state.appStoreSecret_error = true;
                state.hasAppStoreSecret = false;
                break;
            case 'ACCOUNTS_FIREBASE_APP_SETUP_REQUEST':
                state.check_loading = true;
                state.check_error = false;
                break;
            case 'ACCOUNTS_FIREBASE_APP_SETUP_SUCCESS':
                state.check_loading = false;
                state.check_error = false;
                state.androidBundleId = action.androidBundleId || '';
                break;
            case 'ACCOUNTS_FIREBASE_APP_SETUP_FAILURE':
                state.check_loading = false;
                state.check_error = true;
                break;
            case 'ACCOUNTS_FIREBASE_APP_CHECK_REQUEST':
                state.check_loading = true;
                state.check_error = false;
                break;
            case 'ACCOUNTS_FIREBASE_APP_CHECK_SUCCESS':
                state.check_loading = false;
                state.check_error = false;
                state.androidBundleId = action.androidBundleId || '';
                state.androidBundleCheckAppId = action.androidBundleCheckAppId || '';
                break;
            case 'ACCOUNTS_FIREBASE_APP_CHECK_FAILURE':
                state.check_loading = false;
                state.check_error = true;
                state.androidBundleId = '';
                break;
            case 'ACCOUNTS_FIREBASE_SAVE_SECRET_REQUEST':
                state.firebaseSecretSave_loading = true;
                state.firebaseSecretSave_error = false;
                break;
            case 'ACCOUNTS_FIREBASE_SAVE_SECRET_SUCCESS':
                state.firebaseSecretSave_loading = false;
                state.firebaseSecretSave_error = false;
                state.hasFirebaseSecret = true;
                break;
            case 'ACCOUNTS_FIREBASE_SAVE_SECRET_FAILURE':
                state.firebaseSecretSave_loading = false;
                state.firebaseSecretSave_error = true;
                break;
            case 'CERTIFICATE_DETAILS_REQUEST':
                state.certificateDetails_loading = true;
                state.certificateDetails_error = false;
                break;
            case 'CERTIFICATE_DETAILS_SUCCESS':
                state.certificateDetails_loading = false;
                state.certificateDetails_error = false;
                state.certificateDetails = action.certificateDetails;
                break;
            case 'CERTIFICATE_DETAILS_FAILURE':
                state.certificateDetails_loading = false;
                state.certificateDetails_error = true;
                state.certificateDetails = [];
                break;
            case 'REVOKE_LICENSE_REQUEST':
                state.revoke_loading = true;
                state.revoke_error = false;
                break;
            case 'REVOKE_LICENSE_SUCCESS':
                state.revoke_loading = false;
                state.revoke_error = false;
                break;
            case 'REVOKE_LICENSE_FAILURE':
                state.revoke_loading = false;
                state.revoke_error = true;
                break;
            case 'CREATE_LICENSE_REQUEST':
                state.createLicense_loading = true;
                state.createLicense_error = false;
                break;
            case 'CREATE_LICENSE_SUCCESS':
                state.createLicense_loading = false;
                state.createLicense_error = false;
                break;
            case 'CREATE_LICENSE_FAILURE':
                state.createLicense_loading = false;
                state.createLicense_error = true;
                break;
            case 'ACCOUNTS_FIREBASE_HAS_SECRET_REQUEST':
                state.firebaseSecret_loading = true;
                state.firebaseSecret_error = false;
                state.hasFirebaseSecret = false;
                state.firebaseProjectId = '';
                break;
            case 'ACCOUNTS_FIREBASE_HAS_SECRET_SUCCESS':
                state.firebaseSecret_loading = false;
                state.firebaseSecret_error = false;
                state.firebaseProjectId = action.projectId || '';
                state.hasFirebaseSecret = true;
                break;
            case 'ACCOUNTS_FIREBASE_HAS_SECRET_FAILURE':
                state.firebaseSecret_loading = false;
                state.firebaseSecret_error = true;
                state.hasFirebaseSecret = false;
                state.firebaseProjectId = '';
                break;
            case 'PLATFORM_WEB_PUBLICATION_REQUEST':
                state.webPublication_loading = true;
                state.webPublication_error = false;
                break;
            case 'PLATFORM_WEB_PUBLICATION_SUCCESS':
                state.webPublication_loading = false;
                state.webPublication_error = false;
                state.webMeta = {
                    name: action.name || null,
                    icon: action.icon || null,
                    bgColor: action.bgColor || '#FFFFFF',
                    textColor: action.textColor || '#828282',
                };
                break;
            case 'PLATFORM_WEB_PUBLICATION_FAILURE':
                state.webPublication_loading = false;
                state.webPublication_error = true;
                state.webMeta = {
                    name: null,
                    icon: null,
                    bgColor: '#FFFFFF',
                    textColor: '#828282',
                };
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_SUCCESS':
                state.loading = false;
                state.error = false;
                state.subdomain = action.subdomain || '';
                state.hasSubdomain = state.subdomain !== '';
                state.subdomainAppId = action.subdomainAppId || '';
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_FAILURE':
                state.loading = false;
                state.error = true;
                state.hasSubdomain = false;
                state.subdomain = '';
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_CHECK_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_CHECK_SUCCESS':
                state.loading = false;
                state.error = false;
                state.available = !!action.available;
                state.hasSubdomain = false;
                state.tempSubdomain = (action === null || action === void 0 ? void 0 : action.subdomain) || '';
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_CHECK_FAILURE':
                state.loading = false;
                state.error = true;
                state.available = false;
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_CHECK_RESET':
                state.available = false;
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_DELETE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_DELETE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'PLATFORM_WEB_SUBDOMAIN_DELETE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.hasSubdomain = false;
                state.subdomain = '';
                break;
            case 'GET_LICENSE_SUCCESS':
                state["".concat(action.platform, "_license")] = action.bundle;
                break;
            case 'HAS_LICENSE_REQUEST':
                state.has_license_loading = true;
                break;
            case 'HAS_LICENSE_SUCCESS':
                state.has_license_loading = false;
                break;
            case 'HAS_LICENSE_FAILURE':
                state.has_license_loading = false;
                break;
            default:
                break;
        }
    });
}
export default platformReducer;
